/**
 * Tag palette keys (spec-63, design §4.8). The colour values are CSS tokens in
 * `index.css` (`--tag-<key>-dot/-light/-deep/-glow`); the backend keeps the same keys in
 * `backend/app/crm/palette.py` and `backend/tests/test_crm_style_parity.py`
 * compares the two lists. These are no status colours (DS-2): status uses `tone`.
 */
export const TAG_COLORS = [
  'grijs',
  'rood',
  'oranje',
  'amber',
  'limoen',
  'groen',
  'teal',
  'blauw',
  'indigo',
  'paars',
  'roze',
  'bruin',
] as const

export type TagColor = (typeof TAG_COLORS)[number]

export function isTagColor(value: string): value is TagColor {
  return (TAG_COLORS as readonly string[]).includes(value)
}

/** Unknown or missing keys fall back to grey, so an odd row never breaks a chip. */
export function tagColor(value: string | null | undefined): TagColor {
  return value && isTagColor(value) ? value : 'grijs'
}

/** The CSS variable for one part of a palette colour. */
export function tagVar(color: string | null | undefined, part: 'dot' | 'light' | 'deep' | 'glow'): string {
  return `var(--tag-${tagColor(color)}-${part})`
}
